module.exports = __webpack_public_path__ + "img/reward_6400.745c9f74.png";